import { Badge } from "@/components/ui/badge";

const MAP = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  open: { label: "Open for Bids", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  accepted: { label: "Accepted", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  completed: { label: "Completed", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  cancelled: { label: "Cancelled", cls: "bg-red-50 text-red-700 border-red-200" },
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  declined: { label: "Declined", cls: "bg-red-50 text-red-700 border-red-200" },
  withdrawn: { label: "Withdrawn", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function StatusBadge({ status, ...props }) {
  const s = MAP[status] || MAP.open;
  return (
    <Badge variant="outline" className={`${s.cls} font-medium`} {...props}>
      {s.label}
    </Badge>
  );
}
